import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './metrics.hbs'
import ScorecardsDisplayHeader from 'scoreboard/scorecards/scorecards-display-header'
import conductor from 'scoreboard/components/conductor'
import HeaderControlsPositioner from 'scoreboard/components/header-controls-positioner'
import tabs from '../scorecards-tabs.hbs'
import DisplayOptionsForm from './display-options-form'
import Tooltip from 'scoreboard/components/tooltip'
import globals from 'scoreboard/components/globals'
import JsonStreamer from 'scoreboard/components/json-streamer'
import scrollContainer from 'scoreboard/components/scroll-container'
import SendToOptions from 'scoreboard/components/send-to-options'
import MetricTable from './metrics-table'
import noMetrics from './no-metrics.hbs'
import LoadingDots from 'scoreboard/components/loading-dots'
import spectator from 'scoreboard/components/spectator'
import { streamLoaderPromise } from 'scoreboard/components/export/stream-loader'
import mobile from 'scoreboard/components/mobile'
import visible from 'scoreboard/scorecards/visible'
import calendars from 'scoreboard/components/calendars'
import SortableStreamedTableView from 'scoreboard/components/sortable-streamed-table-view'
import layoutManager from 'scoreboard/components/layout-manager'
import ScorecardNode from 'scoreboard/scorecards/scorecard-node'
import constants from 'scoreboard/components/constants'
import ImportOptions from 'scoreboard/components/import-options'

const scoredFields = ['actual', 'score', 'goal', 'variance', 'variancePercent', 'towardGoalPercent']
const numericFields = ['id', 'impact'].concat(scoredFields)

var Metrics = Backbone.View.extend({
	deferredReady: true,

	className: 'display-layout table-hack scroll-layout-xy scorecards-metrics',

	events: {
		'click tbody a': 'overview',
		'touchend tbody a': 'overview',
		'click .icon-display-options': 'displayOptions'
	},

	/**
	 * @constructs
	 * @param {object} options.scorecardItem
	 */
	initialize: function(options) {
		this.options = options
		var sendToOptions = SendToOptions.default({
			excelFn: this.exportTable.bind(this)
		})

		if (this.model.attributes) { // Allow a simple constructor for tests
			var MetricsHeader = ScorecardsDisplayHeader.extend({
				redrawDisplay: this.changePeriod.bind(this)
			})

			this.header = new MetricsHeader({
				model: this.model,
				subsection: 'metrics',
				tabs: tabs(this.model.attributes),
				sendToOptions: sendToOptions
					.concat(SendToOptions.scorecardStructureImport())
					.concat(SendToOptions.scorecardValueImport())
				//#33271 defer the import options until we get the node back
				//from the server
			})
		}

		_.bindAll(this, 'positionDisplayOptions')

		// add sorting capability. Note the fields property is not defined here but added on later when setting up
		// the metric table
		this.sortableTable = new SortableStreamedTableView({
			el: this.el,
			numeric: numericFields,
			extractSortData: (item, field, state) => {
				if (_.isNil(field)) {
					return null
				}
				let periodId = parseInt(state.periodVar, 10)
				let target = item
				if (_.isFinite(periodId) && _.findIndex(scoredFields, (f) => f == field) != -1) {
					target = !visible(item, calendars.periodsById[periodId]) ? null : _.find(item.scores || [], (score) => {
						return score.periodId === periodId
					})
				}
				return _.get(target, field, null)
			}
		})
		this.listenTo(this.sortableTable, 'sorted', (stream) => {
			//do not allow sorting if show parents option is checked
			if (!!this.displayOptions.showParents) return

			this.setupStream(stream)
			// re-render the table, must setup the stream first
			this.setDisplayOptions(this.displayOptions)
		})
	},

	/**
	 * Invoked by scorecards-router.js when json-streamer processes the data
	 * Object map is defined by ScorecardMetricsResponse.java
	 * @param sn.organizationId
	 * @param sn.label
	 * @param sn.descendantLowestScore
	 */
	setScorecardNode: function(sn) {
		// This view is started with just the node id in the model
		// So we must update it here as soon as it's streamed
		// (so alert subscriptions are available, at a minimum)
		this.model = new ScorecardNode(sn)
		this.header.model = this.model
		this.header.updateOptions({
			importOptions: ImportOptions.forScorecardItem(this.model)
		})
		this.header.render().styleAlertButton()

		this.orgId = sn.organizationId
		this.label = sn.label
		this.descendantLowestScore = sn.descendantLowestScore
		if (!spectator.getCurrent()) {
			globals.orgId = this.orgId
		}
		// #12995 when we reach here, we know the headers were received and the
		// permissions were set, and we also finally know the org ID so we
		// finally have all the info we need to toggle the edit tab
		// appropriately
		this.secure()

		this.handlePendingDeletion()
	},

	/**
	 * Invoked by scorecards-router.js when json-streamer processes the data
	 * @param displayOpts all attribues of DisplayOptions.java are available
	 */
	setDisplayOptions: function(displayOpts) {
		this.displayOptions = displayOpts
		// We can reference this here because setScorecardNode is invoked first
		this.$('header h1').text(this.label)
		this.header.toggleRedDescendants(this.descendantLowestScore)

		var opts = {
			el: this.el,
			scrollEl: this.scrollEl,
			displayOptions: displayOpts,
			sort: this.options.sort || {}
		}

		//undelegate the previous metric table events so that events on previous
		//table view aren't fired causing multiple events
		this.metricTable && this.metricTable.undelegateEvents()
		this.metricTable = new MetricTable(opts)

		this.listenToOnce(this.metricTable, 'sortableTableHeaderFields', (fields) => {
			this.sortableTable.renderHeaders(fields)
		})

		// Pass this through so the router can react to visibility for exports
		this.metricTable.on('visible', () => {
			this.trigger('visible')
			this.$('.panel').removeClass('is-not-displayed')
		})
		this.$el.append(this.metricTable.el)
		this.metricTable.render()
		// 'stream' is emitted on json-streamer.start() but we only want to set
		// this here since we likely will not have gotten the scorecard node
		// and header data that is required to render the table
		this.metricTable.stream(this.stream)
		this.metricTable.on('scroll', this.positionDisplayOptions.bind(this))
		// Wait till the table is finished rendering before initially positioning
		// the display options
		this.metricTable.on('dataRendered', this.positionDisplayOptions.bind(this))
		this.metricTable.on('streamEnd', numMetrics => this.handleMetricResultCount(numMetrics))
	},

	setupStream: function(stream) {
		// #8479 clean up old streams if the display options changed!
		_.result(this.stream, 'removeAllListeners')
		this.stream = stream
		this.fullyLoaded = this.stream.endEmitted || false // Used for export view
		this.sortableTable.observeStream(stream)
		this.stream.on('end', function() {
			this.fullyLoaded = true
		}.bind(this))
	},

	handleMetricResultCount: function(numMetrics) {
		const hasNoMetrics = numMetrics === 0
		this.$('.metrics-table-container').toggleClass('is-not-displayed', hasNoMetrics)
		this.$el.toggleClass('empty-display', hasNoMetrics)

		if (hasNoMetrics) {
			this.$('.display-pane-body').append(noMetrics())
			this.handlePendingDeletion()
		} else {
			this.$('.empty-state').remove()
		}
	},

	handlePendingDeletion: function() {
		if (this.model.get('pendingDeletion')) {
			this.$('.banner.pending-deletion').removeClass('is-not-displayed')
		}
	},

	render: function () {
		this.$el.append(this.header.el, template())
		this.header.render()

		// hide the metrics report until there's data to display
		this.$('.metrics-table').addClass('is-not-displayed')

		if (layoutManager.export) {
			this.$('.icon-display-options').addClass('is-not-displayed')
		}

		this.loadingDots = new LoadingDots({
			el: this.$('.loading-dots-container')
		}).render()

		this.renderTable()

		this.loadingDots.observeStream(this.stream)

		this.secure()

		this.positionDisplayOptions()

		return this
	},

	positionDisplayOptions: function() {
		this.controlsPositioner.setHeaderControlsPosition()
	},

	renderTable: function() {
		this.scrollEl = scrollContainer(this.el)
		$(window).on('resize', this.positionDisplayOptions)
		this.on('resize', this.positionDisplayOptions)

		this.controlsPositioner = new HeaderControlsPositioner({
			positionedElement: this.$('.icon-display-options'),
			scrollElement: this.$('.metrics-table'),
			scrollContainer: this.scrollEl
		})
	},

	overview: function(e) {
		if (mobile.isTouchMoving()) {
			return
		}
		var id = $(e.target).data('id')
		var section = $(e.target).data('section') || 'scorecards'
		conductor.overview(section, id)
	},

	displayOptions: function(e) {

		if (this.tooltip) {
			return
		}

		// TODO: handle clicking on this over and over (right now lots of
		// copies of the tooltip are created)
		var target = $(e.currentTarget)

		$.get('api/scorecards/' + this.model.id + '/metrics/display-options', function(data) {
			this.displayOptionsForm = new DisplayOptionsForm({ data: data }).render()
			var tooltip = this.tooltip = new Tooltip({
				className: 'tooltip no-max-width metrics-display-options-tooltip',
				attachTo: target,
				content: this.displayOptionsForm.el,
				placement: 'below',
				arrow: 'right'
			}).render()
			this.listenTo(this.displayOptionsForm, 'cancel', tooltip.remove.bind(tooltip))
			this.listenTo(this.displayOptionsForm, 'done', this.changeDisplayOptions.bind(this))
			this.listenTo(this.tooltip, 'remove', this.removeTooltip.bind(this))
		}.bind(this))
	},

	changeDisplayOptions: function(options) {
		this.displayOptions = options
		this.streamWithOptions(globals.periodId, options)
	},

	changePeriod: function(newPeriodId) {
		this.streamWithOptions(newPeriodId, this.displayOptions)
	},

	streamWithOptions: function(periodId, options) {

		// #29615 If period is changed rapidly over a slow connection cancel previous stream
		_.invoke(this.streamer, 'abort')

		// #13202 always need to send the display options to support read-only
		// users who can't change their personal preferences
		var url = 'api/scorecards/' + this.model.id + '/metrics/display-options?calendarPeriodId=' + periodId
		this.streamer = JsonStreamer.initiate(this, {
			stream: 'metrics',
			method: 'post',
			url,
			contentType: constants.CONTENT_TYPES.APPLICATION_JSON,
			data: JSON.stringify(options)
		}, {
			dataFn: (key,value) => this._onStreamData(key)
		})
		//we're using a new json stream that will have new data, so delete
		//the previous data cache for sorting
		delete this.allDataLoaded
	},

	_onStreamData: function(key) {
		// This can only be invoked once, after we have the display info
		if (key === 'displayOptions') {
			this.tooltip && this.tooltip.remove()
			this.renderTable()
			this.positionDisplayOptions()
			// Re-render the display pane in order to account for the updated
			// table size
			this.trigger('render:display')
		}
	},

	removeTooltip: function() {
		this.tooltip = null
		this.displayOptionsForm = null
	},

	secure: function() {
		// #12995 this is called multiple times.  It's called when initially
		// rendering the screen before the stream has sent back any data.  If
		// we don't already know org permissions the edit tab will start off
		// hidden in that case.  Then after headers have been received from
		// the stream this is called again, and the tab is shown if appropriate
		let editable = this.model.isEditable()
		this.header.conditionallyHideEditTab(editable)
	},

	/**
	 * Initiates an excel download
	 */
	exportTable() {
		return streamLoaderPromise(this, this.stream).then(() => {
			return this.metricTable.exportTable(this.label)
		})
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.header, this.metricTable, this.displayOptionsForm,
			this.tooltip, this.loadingDots], 'remove')
		$(window).off('resize', this.positionDisplayOptions)
	}

})

export default Metrics

Metrics.__filename__ = 'scorecards/metrics/metrics.js'
